<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-bigger`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.50781 5.49512C6.70253 5.68972 7.01814 5.68966 7.21289 5.49512L9.80371 2.9043V4.7002C9.80371 4.97565 10.0273 5.19922 10.3027 5.19922C10.5782 5.1992 10.8018 4.97564 10.8018 4.7002V1.7002C10.8017 1.42477 10.5782 1.20119 10.3027 1.20117H7.30273C7.02729 1.20117 6.80373 1.42476 6.80371 1.7002C6.80371 1.97565 7.02728 2.19922 7.30273 2.19922H9.09863L6.50781 4.79004C6.31326 4.98479 6.31321 5.3004 6.50781 5.49512ZM4.69727 10.8047C4.97271 10.8047 5.19627 10.5811 5.19629 10.3057C5.19629 10.0302 4.97272 9.80664 4.69727 9.80664H2.90137L5.49219 7.21582C5.68674 7.02107 5.68679 6.70546 5.49219 6.51074C5.29747 6.31614 4.98186 6.31619 4.78711 6.51074L2.19629 9.10156V7.30566C2.19629 7.03021 1.97272 6.80664 1.69727 6.80664C1.42183 6.80666 1.19824 7.03022 1.19824 7.30566V10.3057C1.19825 10.4792 1.28633 10.6332 1.4209 10.7227C1.42512 10.7255 1.43028 10.7268 1.43457 10.7295C1.51092 10.7769 1.60082 10.8047 1.69727 10.8047H4.69727Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineBigger',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
